const historyModule = {
    namespaced: true,
    state: {
        status: {
            customer: true,
            animal: false,
            addingCustomer: false,
            addingAnimal: false
        }
    },
    mutations: {
        SET_STATUS: (state, data) => {
            (state.status.customer = data.customer),
                (state.status.animal = data.animal);
        },
        SET_ADDING: (state, data) => {
            (state.status.addingCustomer = data.addingCustomer),
                (state.status.addingAnimal = data.addingAnimal);
        }
    },
    actions: {
        changeStatus({ commit }, payload) {
            commit("SET_STATUS", payload);
        },
        setAdding({ commit }, payload) {
            commit("SET_ADDING", payload);
        }
    },
    getters: {
        getStatus(state) {
            return state.status;
        }
    }
};

export default historyModule;
